import React from 'react';
import Menu from './Menu';
import Podium from 'challenge/common/Podium';
import Leaderboard from './Leaderboard';

export default function Toplist(): React.ReactElement {
  return (
    <>
      <Menu />
      <Podium />
      <Leaderboard />
    </>
  );
}
